import { MenuItem } from '@mui/material';
import EventLocalizedText from 'components/EventLocalizedText';
import { EventWaitingLine } from 'lib/graphql/entities/waitingLines/types';
import { FormattedMessage } from 'react-intl';
import { RoundedSelect } from 'styles/styles';

interface WaitingLineSelectorProps {
  onChange: (waitingLineId: string) => void
  selectedWaitingLine: string
  waitingLines: EventWaitingLine[] | undefined
}

function WaitingLineSelector(props: WaitingLineSelectorProps) {
  const { onChange, selectedWaitingLine, waitingLines = [] } = props;

  return (
    <RoundedSelect
      value={selectedWaitingLine}
      onChange={(event) => onChange(event.target.value as string)}
    >
      <MenuItem value="all">
        <FormattedMessage id="filter_all_waiting_lines" />
      </MenuItem>
      {waitingLines.map((line) => (
        <MenuItem key={line.id} value={line.id}>
          <EventLocalizedText text={line.name} />
        </MenuItem>
      ))}
    </RoundedSelect>
  );
}

export default WaitingLineSelector;
